"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onError;
function onError(event) {
  clearTimeout(this._timeUpdateInterval);
  this.logger.logIssue('Error', this.rawPlayer.error);
  this._playerState.error = event.message;
  this.emit('error', event);
}